
import ExternalConfiguration from '../../external-configuration';

import './BlockedContentImage.css';

export default function BlockedContentImage( props) {
  return <img className='BlockedContentImage' alt='BlockedContentImage' src={ExternalConfiguration.DefaultBlockedContentImage} />;
}